export default __webpack_public_path__ + "static/media/account.2d74bbd8.svg";